// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class AdvancedDatepickersController {
   $scope: any
   advancedSearch: any
   dateRange: any
   translationService: any
   constructor($scope: any, dateRange: any, translationService: any, advancedSearch: any) {
      this.setSelection = this.setSelection.bind(this)
      this.retrieveSince = this.retrieveSince.bind(this)
      this.clear = this.clear.bind(this)
      this.resetValidity = this.resetValidity.bind(this)
      this.$scope = $scope
      this.dateRange = dateRange
      this.translationService = translationService
      this.advancedSearch = advancedSearch
      this.$scope.range = this.dateRange.range
      this.$scope.selection = _.clone(this.dateRange.selection)
      this.$scope.setSelection = this.setSelection
      this.$scope.retrieveSince = this.retrieveSince
      this.$scope.clear = this.clear
      this.$scope.datePresets = this.dateRange.defaultPresets
      this.$scope.datePresetLabels = this.dateRange.datePresetLabels
      this.$scope.i18n = this.translationService
      this.advancedSearch.on('clearDate', (clearingAllAdvanced: boolean) => {
         return this.clear(null, clearingAllAdvanced)
      })
      this.advancedSearch.on('reflectDate', (params: any) => {
         this.reflectOnDemand(params)
      })
      this.dateRange.on('setAdvancedSelection', (params: any) => {
         this.setSelection(params)
      })
   }

   setSelection(selection: any) {
      this.$scope.selection.start = selection.start
      this.$scope.selection.end = selection.end
      this.$scope.selection.selectedYears = selection.selectedYears
      return this.advancedSearch.setDateSelection(selection)
   }

   retrieveSince(years: any, $event: any) {
      $event.preventDefault()
      const scopeLabel = this.advancedSearch.scope.newSearchScope || this.advancedSearch.scope.searchScope
      const advScopeParams = this.advancedSearch.scope.searchScopeParams
      const retrieveSinceCallBack = (goBackToSearchScope = false) => {
         if(!goBackToSearchScope){
            const selection = this.dateRange.retrieveSince(years)
            selection.selectedYears = years
            this.setSelection(selection)
            // we can force validity since this function is only used for presets
            this.resetValidity()
         }
      }
      if(this.dateRange.checkForSearchScope(scopeLabel, advScopeParams, retrieveSinceCallBack)){
         return
      }

      retrieveSinceCallBack()
      
   }

   clear($event: any, clearAllAdvancedSearch = false) {
      if ($event) {
         $event.preventDefault()
      }
      const scopeLabel = this.advancedSearch.scope.newSearchScope || this.advancedSearch.scope.searchScope
      const advScopeParams = this.advancedSearch.scope.searchScopeParams
      if(!clearAllAdvancedSearch && this.dateRange.checkForSearchScope(scopeLabel, advScopeParams)){
         return
      }
      this.setSelection({start: null, end: null, selectedYears: null})
      // we can force validity since this function is only used for clearing
      return this.resetValidity()
   }

   reflectOnDemand(params: any){
      let from = null
      let to   = null
      const rangeFacet = _(params.rf).find((f: any) => f.indexOf('PublicationDate') === 0)
      const date = new Date()

      if (rangeFacet) {
         const range = rangeFacet.split(",")[1].replace(/\-/g, '/');
         [from, to] = range.split(":").map(function(d: any) { if (d !== "*") { return new Date(d) } else { return null } })
      }
      const selectedYears = this.dateRange.determinePresetSelectedYears(from, to)
      if (selectedYears){
         to = null
      }
      this.setSelection({
         start: from,
         end: to,
         selectedYears
      })
   }

   resetValidity() {
      // workaround, when opening, closing and opening the adv search dialog, the advancedSearchForm disappears from the $scope
      // not sure where to make the changes to fix this
      if (this.$scope.advancedSearchForm) {
         this.$scope.advancedSearchForm.facetDatePicker.sliderFrom.$setValidity('parseDate', true)
         return this.$scope.advancedSearchForm.facetDatePicker.sliderTo.$setValidity('parseDate', true)
      }
   }
}


AdvancedDatepickersController.$inject = ['$scope', 'dateRangeService','translationService', 'advancedSearchService']

angular.module('summonApp.controllers').controller('AdvancedDatepickersCtrl', AdvancedDatepickersController)
